@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.signInTitleBreak {
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
}

.signInWrapper {
  display: flex;
  padding: 40px 24px;
  border-radius: 16px;
  border: 2px solid v.$gray-border-panel-color;
  background: v.$gradient-form-card;
  backdrop-filter: blur(1px);

  @media (min-width: 768px) {
    width: 440px;
    margin: 0 auto;
    padding: 40px;
  }

  @media (min-width: 1200px) {
    width: 100%;
    max-width: 1170px;
    gap: 40px;
  }
}

.signInContent {
  flex: 1;

  @media (min-width: 1200px) {
    max-width: 360px;
    padding-top: 72px;
  }
}

.signInTitle {
  @include t.text(36px, 48px, "bold");
  color: v.$white-color;
  margin-bottom: 16px;
}

.formDescriptionTermsLink,
.formDescription {
  display: inline-block;
  margin-bottom: 16px;
  color: v.$gray-light-color;
  @include t.text(14px, 22px, "normal");
}

.formDescriptionTermsLink {
  text-decoration: underline;
  cursor: pointer;
}

.formDescriptionSeparator {
  display: flex;
  justify-content: center;
  margin: 16px auto;
  color: v.$gray-light-color;
  @include t.text(14px, 22px, "normal");
}

.formButton {
  cursor: pointer;
  width: 100%;
  display: flex;
  gap: 8px;
  height: 48px;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: v.$green-color;
  @include t.text(16px, 26px, "semi-bold");
  color: v.$white-color;

  &:disabled {
    cursor: not-allowed;
  }
}

.formDescriptionLink {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin: 16px auto;
  color: v.$gray-light-color;
  @include t.text(14px, 22px, "normal");

  span {
    cursor: pointer;
    text-decoration: underline;
  }
}

.signInBackgroundImage {
  position: relative;
  display: none;
  flex: 1;

  @media (min-width: 1200px) {
    display: block;
    border-radius: 16px;
    overflow: hidden;
    max-height: 800px;
  }

  .logoIcon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 365px;
    height: 61px;
  }
}

/* Chinese Brothers */

.signInWrapperChineseBrothers {
  border: 1px solid v.$chinese-brothers-border-color;
  background: v.$chinese-brothers-card-bg;
}

.formButtonChineseBrothers {
  background: v.$white-color;
  color: v.$navy-dark-color-2;
}

.signInBackgroundImageChineseBrothers {
  @media (min-width: 1200px) {
    display: flex;
    align-items: center;
    justify-content: center;
    isolation: isolate;
    border-radius: 24px;
    border: 1px solid v.$chinese-brothers-border-color;
    background: v.$navy-dark-color-2;
  }
}

.chineseBrothersGlowTop,
.chineseBrothersGlowBottom {
  position: absolute;
  left: -1px;
  right: -1px;
  height: 12%;
  min-height: 80px;
  border-radius: 940px;
  background: rgb(255 41 41 / 50%);
  filter: blur(106px);
  pointer-events: none;
}

.chineseBrothersGlowTop {
  top: -1px;
  z-index: 2;
}

.chineseBrothersGlowBottom {
  bottom: -1px;
  z-index: 1;
}

.chineseBrothersLogo {
  position: relative;
  z-index: 3;
  width: 399px;
  height: 48px;
  max-width: 90%;
}

.errorMessage {
  color: v.$error-color;
  @include t.text(14px, 22px, "normal");
  text-align: center;
  margin-top: 16px;
}

.continueWith {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  color: v.$gray-light-color;
  @include t.text(14px, 22px, "normal");
}

.loader {
  width: 30px;
}
